define(function(require, exports, module) {
    var nav = require('./unit/nav/navV2');
    var placeholder = require('./unit/placeholder/placeholder');
    var lazyload = require('./unit/lazyload/lazyload');
    var newprice = require('./unit/newprice/newprice');
    var timeModel = require("./model/timeModel/timeModel");
    var slide = require('./unit/slide/slide');
    var search = require('./unit/search/search');
    var setUserInfo = require('./unit/setUserInfo/setUserInfo');

    setUserInfo();
    search.addSearchEvent();
    slide.slideBox({
        data: slide.getImgData("tempHideInput"),
        backgroundImg: true,
        directBtn: true,
        duration: 0.3, //滚动持续时间，单位：秒
        direction: 'fadein',
        delay: 3, //滚动延迟时间，单位：秒
        hideClickBar: false, //不自动隐藏点选按键
        clickBarRadius: 10,
        width: 1210,
        height: 390,
        id: "slideOne"
    });

    nav.control.init();
    nav.handleNav();
    lazyload.fn.init();
    placeholder.init();
    newprice.fn.init();
    timeModel.calculateSecondCount();
});



// WEBPACK FOOTER //
// ./src/js/specialSale.js